import { UserAvatarReadOnly } from '@/pages/+settings/workspace/_base/UserAvatarReadOnly';
import { SEPARATOR__horizontal_dashed } from '@/pages/_base/separators/SEPARATOR__horizontal_dashed';
import { get_entity_viewer_color_as_workspace_user } from '@/utils/utils_client_workspace_child_entity_viewers';
import { DropdownMenuLabel } from '@radix-ui/react-dropdown-menu';
import { DTOWorkspaceChildEntityViewer } from '@shared/dto/+workspace/workspace_entity/dto_workspace_child_entity_viewer';
import { FC } from 'react';

interface Props {
  viewers: DTOWorkspaceChildEntityViewer[][];
  workspace_viewers_ids: string[];
}

export const BarGrid2dViewersChunk: FC<Props> = ({ viewers, workspace_viewers_ids }) => {
  return (
    <>
      {viewers.map((row, row_index) => (
        <DropdownMenuLabel key={`row-${row_index}`} className="flex items-center space-x-2 px-2 py-1 max-h-[32px] min-h-[32px]">
          {row.map(user => (
            <UserAvatarReadOnly
              key={`grid2d_viewer_${user.get_viewer_id()}`}
              url_relative={user.user_avatar_url_relative}
              userName={user.user_name}
              className="!size-5"
              style={{ borderColor: `var(--user-color-${get_entity_viewer_color_as_workspace_user(user, workspace_viewers_ids)})` }}
            />
          ))}
        </DropdownMenuLabel>
      ))}
      <SEPARATOR__horizontal_dashed />
    </>
  );
};
